import React, {useContext} from 'react'
import Slide from './Slide'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Skeleton } from '@chakra-ui/react';
import { Context } from './context/Context';




function RecipeBoxCarousel() {

    const{isCarouselLoading, carouselSlides}=useContext(Context)
    
// console.log(carouselSlides)
  return (

    <Skeleton height={'95vh'} isLoaded={isCarouselLoading}>
        <section id="Home">
            <Carousel autoPlay={true} infiniteLoop={true} interval={7000} showStatus={false} showThumbs={false} >
                {carouselSlides.map((item) => {
                    const {id, slideBg, slideTitle, slideDescription} = item

                    return (
                        <Slide key={id} slideTitle={slideTitle} slideBg={slideBg} slideDescription={slideDescription}/>
                    )
                })}
            </Carousel>
            
        </section>
    </Skeleton>
  )
}

export default RecipeBoxCarousel